import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { fetchArticlesExpenditures, fetchFilials, } from '../../action/handbook';
import Loader from '../utils/Loader';
import Portlet from '../utils/Portlet';
import ErrorContainer from '../utils/ErrorContainer';
import { setUIvisible } from '../../action/UImobile';
import { fetchOtherExpenditures, setCassaFilters, setDetailArticle } from '../../action/cassa';
import Select from 'react-select';
import moment from 'moment';
import '../../styles/cassa.css'
import { setActiveModalAction } from '../../action';
import DateInput from '../utils/DateInput';
import OtherExpendituresTable from './OtherExpendituresTable';
import { roleId } from '../../constants/app';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
}

class OtherExpenditureList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            articlesFilters: {
                name: null,
                typeTransaction: null
            }
        };
    }

    setArticleFilters = (field) => (e) =>  {
        const data = {...this.state.articlesFilters};

        if (e.value) {
            data[field] = e;
        } else {
            data[field] = null;
        }

        this.setState({ articlesFilters: data });
    }


    componentDidMount() {
        const getData = async () => {
            let date = new Date();
            date.setDate(1);
            date.setHours(0, 0, 0, 0);

            await Promise.all([
                this.props.fetchFilials(null),
                this.props.fetchArticlesExpenditures(true),
                this.onChangeDateInput('createdStartDate')(date)
            ]);
            
            this.props.setUIvisible(true, false);
            this.props.fetchOtherExpenditures();
        }

        getData();

        if(this.props.role === roleId.manager || this.props.role === roleId.cashier) {
            this.setArticleFilters('typeTransaction')({value: 'cash', label: 'Наличные'});
        }

        if(this.props.role === roleId.accountant || this.props.role === roleId.chiefAccountant) {
            this.setArticleFilters('typeTransaction')({value: 'noncash', label: 'Безнал. '});
        }
    }

    componentWillUnmount(){
        const { filters } = this.props;
        let updated = {
            ...filters
        }

        updated.createdEndDate = null;
        updated.createdStartDate = null;

        this.props.setCassaFilters(updated);
    }

    setFilters = (field) => (data) => {
        const { filters } = this.props;
        let updated = {
            ...filters,
            [field]: data
        }

        if(data.value === null) {
            updated = {
                ...filters,
                [field]: null
            }
        }

        this.props.setCassaFilters(updated);
        this.props.fetchOtherExpenditures();   
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props;

        if(field === 'createdStartDate') {
            date.setHours(0, 0, 0, 0);
        } else {
            date.setHours(23, 59, 59, 999)
        }

        const updated = {
            ...filters,
            [field]: date,
        };

        if (field === 'createdStartDate') {            
            updated.createdEndDate = moment(date).endOf('month').toDate()
        }

        if(updated.createdStartDate && moment(updated.createdEndDate) < moment(updated.createdStartDate)) {
            updated.createdStartDate = moment(updated.createdEndDate).startOf('month').toDate();
        }
        
        this.props.setCassaFilters(updated);
    }

    onSearchDate = () => {
        this.props.fetchOtherExpenditures();
    }

    renderAdress(item) {
        return `${item.city.name}, ${item.street}, ${item.house}`;
    }

    onRefresh = () => {
        this.props.fetchOtherExpenditures();
    }

    checkPointValue() {
        if (this.props.filters.point) {
            return this.props.filters.point;
        }

        if(!this.props.filters.point && (this.props.filials.length === 0 || !this.props.filials[0])) {
            return null;
        }

        if(this.props.filials[0]) {
            return {value: this.props.filials[0].id, label: this.renderAdress(this.props.filials[0])};
        }

        return null;
    }

    onAddArticle() {
        this.props.setActiveModalAction({ field: 'otherExpendituresAddArticles', value: true })
    }

    onEditArticle = (article) => {
        this.props.setDetailArticle(article);
        this.props.setActiveModalAction({ field: 'otherExpendituresEditArticles', value: true });
    }

    disableInputTypeTransaction(){
        if(this.props.loadingArticles || this.props.loadingFilials)
            return false;

        if([roleId.manager, roleId.accountant, roleId.chiefAccountant].includes(this.props.role))
            return false;
    
        return true;
    }

    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Расходы вне смены</h3>
                    <button className="btn btn-secondary btn-icon">
                        <i onClick={this.onRefresh} className='la la-refresh'/>
                    </button>
                    <div className="kt-subheader__group" id="kt_subheader_search">                       
                    </div>
                </div>
                    <div className="kt-subheader__toolbar">                            
                        <button onClick={() => this.onAddArticle()} className='btn btn-dark btn-icon-sm'>
                            + Добавить
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    renderFiltersBlock(){
            return(
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginTop: '10px', gap: '10px'}}>            
                    <div style={{ width: 250 }}>
                        <Select
                        isLoading={this.props.loadingFilials}
                        isDisabled={this.props.loadingFilials}
                        value={this.checkPointValue()}
                        closeMenuOnSelect={true}
                        onChange={this.setFilters('point')}
                        options={this.props.filials.map((el) => ({ value: el.id, label: this.renderAdress(el) }))}
                        placeholder="Филиал"
                        noOptionsMessage={() => 'Нет филиалов'}
                        />
                    </div>
                    {(window.innerWidth > 1024 || this.props.UImobile.openFilters) &&
                    <>
                        <div style={{ width: 150 }}>
                            <Select
                            isLoading={this.props.loadingArticles || this.props.loadingFilials}
                            isDisabled={this.props.loadingArticles || this.props.loadingFilials}
                            value={this.state.articlesFilters.name}
                            closeMenuOnSelect={true}
                            onChange={this.setArticleFilters('name')}
                            options={[
                                {value: null, label: 'Все статьи'},
                                ...this.props.articlesExpenditures
                                    .sort((a, b) => {
                                    if (a.name < b.name) return -1;
                                    if (a.name > b.name) return 1;
                                    return 0;
                                    })
                                    .filter((el) => {
                                    let check = true;

                                    if (this.state.articlesFilters.typeTransaction) {
                                        check = check && (el.typeTransaction === this.state.articlesFilters.typeTransaction.value || el.typeTransaction === 'all');
                                    }

                                    return check;
                                    })
                                    .map(el => ({
                                    value: el.id,
                                    label: el.name
                                }))
                            ]}
                            placeholder="Статья"
                            noOptionsMessage={() => 'Нет статей'}
                            />
                        </div>
                        <div style={{ width: 150 }}>
                            <Select
                            isLoading={this.props.loadingArticles || this.props.loadingFilials}
                            isDisabled={!this.disableInputTypeTransaction()}
                            value={this.state.articlesFilters.typeTransaction}
                            closeMenuOnSelect={true}
                            onChange={this.setArticleFilters('typeTransaction')}
                            options={[
                                {value: null, label: 'Оба типа'},
                                {value: 'cash', label: 'Наличные'},
                                {value: 'noncash', label: 'Безнал. '}
                            ]}
                            placeholder="Тип транзакции"
                            noOptionsMessage={() => 'Нет типов'}
                            />
                        </div>
                        <div className='dateBlock'>
                            <DateInput
                                placeholderText="Дата c"
                                selected={this.props.filters.createdStartDate}
                                onChange={this.onChangeDateInput('createdStartDate')}
                                required={this.props.filters.createdEndDate}
                            />
                            <div>-</div>
                            <DateInput
                                placeholderText="Дата по"
                                selected={this.props.filters.createdEndDate}
                                onChange={this.onChangeDateInput('createdEndDate')}
                                required={this.props.filters.createdStartDate}
                                maxDate={
                                    this.props.filters.createdStartDate ? moment(this.props.filters.createdStartDate).add(31, 'days').toDate() : null
                                }
                            />
                            {
                                this.props.filters.createdStartDate && this.props.filters.createdEndDate &&
                                <div>
                                    <button
                                        className={`btn ${(this.props.list && this.props.list.length > 0) ? 'btn-danger' : 'btn-success'} btn-icon`}
                                        style={{ height: '2.5rem', width: '2.5rem' }}
                                        onClick={this.onSearchDate}
                                    >
                                        <i className={(this.props.list && this.props.list.length > 0) ? 'flaticon2-cross' : 'flaticon2-check-mark'}/>
                                    </button>
                                </div>
                            }
                        </div>
                    </>
                    }
            </div>
            ); 
    }

    render() {
        if (this.props.loading) {
            return (
                <div style={styles.loading}><Loader /></div>
            );
        }  
        
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div className="kt-portlet__body">
                        <div className="kt-form kt-form--label-right kt-margin-b-10">
                            {this.renderFiltersBlock()}
                        </div>
                    </div>
                <Portlet fit={true}>
                    <ErrorContainer field="workingShift" style={{ margin: 15 }} hasCloseButton={true}/>
                    <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
                        <OtherExpendituresTable items={this.props.otherExpenditures || []} filters={this.state.articlesFilters} onEditArticle={this.onEditArticle}/>
                    </div>
                </Portlet>
            </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    filters: state.cassa.filters,
    loading: state.loaders.otherExpenditures,
    otherExpenditures: state.cassa.otherExpenditures,
    articlesExpenditures: state.handbook.articlesExpenditures,
    role: state.user.info.role.id,
    loadingArticles: state.loaders.articleExpenditures,
    loadingFilials: state.loaders.filials,
    filials: state.handbook.filials,
    UImobile: state.UImobile,
});

const mapDispatchToProps = {
    fetchFilials: (city) => fetchFilials(city, true),
    fetchArticlesExpenditures: (isGetAll) => fetchArticlesExpenditures(isGetAll),
    fetchOtherExpenditures: () => fetchOtherExpenditures(),
    setUIvisible: (visibleFiltersButton, visibleActionButton) => setUIvisible(visibleFiltersButton, visibleActionButton),
    setActiveModalAction: (value) => setActiveModalAction(value),
    setCassaFilters: (filters) => setCassaFilters(filters),
    setDetailArticle: (article) => setDetailArticle(article)
}

export default connect(mapStateToProps, mapDispatchToProps)(OtherExpenditureList);